/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import { dateOnlyToQuery } from './DateOnly';
import type {
  CreateEdictRecordsRequest,
  EdictDocumentResponse,
  EdictEntryResponse,
  EdictRecordResponse,
  EdictSource,
  EdictTransferResponse,
  ProblemDetails,
  TransferEdictRequest,
  ValidationProblemDetails,
} from '../models/index';
import {
    CreateEdictRecordsRequestFromJSON,
    CreateEdictRecordsRequestToJSON,
    EdictDocumentResponseFromJSON,
    EdictDocumentResponseToJSON,
    EdictEntryResponseFromJSON,
    EdictEntryResponseToJSON,
    EdictRecordResponseFromJSON,
    EdictRecordResponseToJSON,
    EdictSourceFromJSON,
    EdictSourceToJSON,
    EdictTransferResponseFromJSON,
    EdictTransferResponseToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    TransferEdictRequestFromJSON,
    TransferEdictRequestToJSON,
    ValidationProblemDetailsFromJSON,
    ValidationProblemDetailsToJSON,
} from '../models/index';

export interface CreateEdictRecordsOperationRequest {
    createEdictRecordsRequest: CreateEdictRecordsRequest;
}

export interface GetEdictDocumentRequest {
    sourceReference?: string;
}

export interface GetEdictsRequest {
    source?: EdictSource;
    from?: Date;
    to?: Date;
}

export interface TransferEdictOperationRequest {
    transferEdictRequest: TransferEdictRequest;
}

/**
 * EdictsApi - interface
 * 
 * @export
 * @interface EdictsApiInterface
 */
export interface EdictsApiInterface {
    /**
     * 
     * @param {CreateEdictRecordsRequest} createEdictRecordsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EdictsApiInterface
     */
    createEdictRecordsRaw(requestParameters: CreateEdictRecordsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<EdictRecordResponse>>>;

    /**
     */
    createEdictRecords(requestParameters: CreateEdictRecordsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<EdictRecordResponse>>;

    /**
     * 
     * @param {string} [sourceReference] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EdictsApiInterface
     */
    getEdictDocumentRaw(requestParameters: GetEdictDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EdictDocumentResponse>>;

    /**
     */
    getEdictDocument(requestParameters: GetEdictDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EdictDocumentResponse>;

    /**
     * 
     * @param {EdictSource} [source] 
     * @param {Date} [from] 
     * @param {Date} [to] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EdictsApiInterface
     */
    getEdictsRaw(requestParameters: GetEdictsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<EdictEntryResponse>>>;

    /**
     */
    getEdicts(requestParameters: GetEdictsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<EdictEntryResponse>>;

    /**
     * 
     * @param {TransferEdictRequest} transferEdictRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EdictsApiInterface
     */
    transferEdictRaw(requestParameters: TransferEdictOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EdictTransferResponse>>;

    /**
     */
    transferEdict(requestParameters: TransferEdictOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EdictTransferResponse>;

}

/**
 * 
 */
export class EdictsApi extends runtime.BaseAPI implements EdictsApiInterface {

    /**
     */
    async createEdictRecordsRaw(requestParameters: CreateEdictRecordsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<EdictRecordResponse>>> {
        if (requestParameters['createEdictRecordsRequest'] == null) {
            throw new runtime.RequiredError(
                'createEdictRecordsRequest',
                'Required parameter "createEdictRecordsRequest" was null or undefined when calling createEdictRecords().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/edicts/records`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateEdictRecordsRequestToJSON(requestParameters['createEdictRecordsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(EdictRecordResponseFromJSON));
    }

    /**
     */
    async createEdictRecords(requestParameters: CreateEdictRecordsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<EdictRecordResponse>> {
        const response = await this.createEdictRecordsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getEdictDocumentRaw(requestParameters: GetEdictDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EdictDocumentResponse>> {
        const queryParameters: any = {};

        if (requestParameters['sourceReference'] != null) {
            queryParameters['SourceReference'] = requestParameters['sourceReference'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/edicts/document`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EdictDocumentResponseFromJSON(jsonValue));
    }

    /**
     */
    async getEdictDocument(requestParameters: GetEdictDocumentRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EdictDocumentResponse> {
        const response = await this.getEdictDocumentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getEdictsRaw(requestParameters: GetEdictsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<EdictEntryResponse>>> {
        const queryParameters: any = {};

        if (requestParameters['source'] != null) {
            queryParameters['Source'] = requestParameters['source'];
        }

        if (requestParameters['from'] != null) {
            queryParameters['From'] = dateOnlyToQuery(requestParameters['from'] as Date);
        }

        if (requestParameters['to'] != null) {
            queryParameters['To'] = dateOnlyToQuery(requestParameters['to'] as Date);
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/edicts`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(EdictEntryResponseFromJSON));
    }

    /**
     */
    async getEdicts(requestParameters: GetEdictsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<EdictEntryResponse>> {
        const response = await this.getEdictsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async transferEdictRaw(requestParameters: TransferEdictOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EdictTransferResponse>> {
        if (requestParameters['transferEdictRequest'] == null) {
            throw new runtime.RequiredError(
                'transferEdictRequest',
                'Required parameter "transferEdictRequest" was null or undefined when calling transferEdict().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/edicts/transfer`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TransferEdictRequestToJSON(requestParameters['transferEdictRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EdictTransferResponseFromJSON(jsonValue));
    }

    /**
     */
    async transferEdict(requestParameters: TransferEdictOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EdictTransferResponse> {
        const response = await this.transferEdictRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
